module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('headerpage', {
    attrs: {
      "status": _vm.type == 5 ? 2 : 0
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "deground"
  }, [_c('div', {
    staticClass: "adaptation",
    staticStyle: {
      "background-color": "#f6f8f7"
    }
  }, [(_vm.type == 1 || _vm.type == 2) ? _c('div', {
    staticClass: "hetext"
  }, [_vm._v("首页>政策咨询>详情")]) : (_vm.type == 3) ? _c('div', {
    staticClass: "hetext"
  }, [_vm._v("首页>园区通知>详情")]) : (_vm.type == 4) ? _c('div', {
    staticClass: "hetext"
  }, [_vm._v("首页>园区要闻>详情")]) : (_vm.type == 5) ? _c('div', {
    staticClass: "hetext"
  }, [_vm._v("首页>公共服务>详情")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box_tt"
  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), _c('div', {
    staticClass: "box_tt1"
  }, [_c('span', {
    staticStyle: {
      "color": "#9b9b9b"
    }
  }, [_vm._v("发布时间：")]), _vm._v(" " + _vm._s(_vm.detail.create_time))])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  }), _vm._v(" "), (!_vm.detail.content) ? [_c('Nomore')] : _vm._e()], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-929cf194"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/detail.vue
// module id = 903
// module chunks = 1